import styled from '@emotion/styled/macro';
import { Variables } from '../base';

export const Container = styled.div`
    width: 100%;
    overflow: auto;
    margin-top: 24px;
`;

export const TransmissionInfo = styled.div`
    margin-bottom: 12px;
    font-weight: 500;
    font-size: 14px;
`;

export const LabelsContainer = styled.div`
    margin-bottom: 16px;
    display: flex;
    width: 100%;
`;

export const DiffLabel = styled.div`
    font-weight: 600;
    padding: 8px 12px;
    background-color: ${Variables.Colors.n15};
    border-radius: 4px;
    flex: 1;

    &:not(:last-child) {
        margin-right: 2px;
    }
`;

export const ErrorMessage = styled.div`
    padding: 16px;
    background-color: ${Variables.Colors.r10};
    border: 1px solid ${Variables.Colors.r30};
    border-radius: 4px;
    color: ${Variables.Colors.r50};
    font-size: 14px;
`;

export const DiffContainer = styled.div`
    max-height: 700px;
    overflow: auto;
`;
